import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m8.007 4.548-.77-.05a4.3 4.3 0 0 1-2.216.625c-.831 0-1.6-.225-2.217-.625l-.77.05c-1.2.05-2.093.9-2.031 1.849l.4 5.672c.062.724.8 1.299 1.693 1.299h.123l.74 8.82c.061.825.646 1.274 1.354 1.274h1.416c.708 0 1.293-.45 1.355-1.274l.738-8.82h.123c.893 0 1.663-.575 1.694-1.3l.4-5.671c.061-.95-.862-1.774-2.032-1.85Zm-.002-2.099c0 1.352-1.35 2.449-3.017 2.449S1.971 3.801 1.971 2.449 3.322 0 4.988 0s3.017 1.097 3.017 2.45Zm13.96 2.099-.77-.05a4.3 4.3 0 0 1-2.216.625c-.831 0-1.6-.225-2.216-.625l-.77.05c-1.2.05-2.093.9-2.032 1.849l.4 5.672c.062.724.801 1.299 1.694 1.299h.123l.739 8.82c.061.825.646 1.274 1.354 1.274h1.416c.708 0 1.293-.45 1.355-1.274l.739-8.82h.123c.893 0 1.662-.575 1.693-1.3l.4-5.671c.062-.95-.862-1.774-2.032-1.85Zm.012-2.099c0 1.352-1.351 2.449-3.017 2.449S15.943 3.8 15.943 2.449C15.943 1.097 17.293 0 18.96 0s3.017 1.097 3.017 2.449"
    }, null, -1)
  ]))]))
}
export default { render: render }